import { render, staticRenderFns } from "./TeacherGroupPageTable.vue?vue&type=template&id=4556badd&scoped=true&"
import script from "./TeacherGroupPageTable.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4556badd",
  null
  
)

export default component.exports